if (!customElements.get('product-quick-order')) {
    customElements.define(
        'product-quick-order',
        class ProductQuickOrder extends HTMLElement {
            constructor() {
                super();

                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

                this.selectors = {
                    addToCart: '.button__add-to-cart',
                    quantityInput: 'input[type="number"]',
                    rowWrapper: '.product-quick-order__item',

                    spinner: '.spinner',
                    tableTotal: '.table-total__buc',
                    addAllToCart: '.button__add-all-to-cart',
                    select: '.product-quick-order__select-group',
                    rows: '.product-quick-order__row',
                    selectSummary: '.product-quick-order__summary span',
                    summaryBubble: '.product-quick-order__bubble',
                    errorAddToCartQuantity0: '.error-add-to-cart-quantity-0',
                    price: '.product-quick-order__item-price-current',
                    priceCompare: '.product-quick-order__item-price-compare',
                    priceTd: '.product-quick-order__price',
                };

                this.elements = {
                    addToCart: this.querySelectorAll(this.selectors.addToCart),
                    quantityInput: this.querySelectorAll(this.selectors.quantityInput),
                    rowWrapper: this.querySelectorAll(this.selectors.rowWrapper),
                    tableTotal: this.querySelector(this.selectors.tableTotal),
                    addAllToCart: this.querySelector(this.selectors.addAllToCart),
                    select: this.querySelector(this.selectors.select),
                    rows: this.querySelectorAll(this.selectors.rows),
                    selectSummary: this.querySelector(this.selectors.selectSummary),
                    summaryBubble: this.querySelector(this.selectors.summaryBubble),
                    errorAddToCartQuantity0: this.querySelector(this.selectors.errorAddToCartQuantity0),
                    priceTd: this.querySelectorAll(this.selectors.priceTd),
                };

                this.classes = {
                    loading: 'button--icon-loading',
                    success: 'button--icon-success',
                    error: 'button--icon-error',
                }
            }

            connectedCallback() {
                this.addEventListeners();
                this.priceTdForceKeepWidth();
            }

            priceTdForceKeepWidth() {
                this.elements.priceTd.forEach((priceTd) => {
                    priceTd.style.maxWidth = priceTd.offsetWidth + 'px';
                    priceTd.style.width = priceTd.offsetWidth + 'px';
                });
            }

            addEventListeners() {

                this.elements.quantityInput?.forEach((quantityInput) => {
                    quantityInput.addEventListener('change', () => {
                        this.validateInput(quantityInput);
                        this.updatePrice(quantityInput);
                    });
                });


                this.elements.addAllToCart?.addEventListener('click', async () => {

                    if ([...this.elements.quantityInput].every(quantityInput => quantityInput.value === '0')) {
                        this.elements.errorAddToCartQuantity0.classList.remove('hidden');
                        return;
                    } else {
                        if (!this.elements.errorAddToCartQuantity0.classList.contains('hidden')) {
                            this.elements.errorAddToCartQuantity0.classList.add('hidden');
                        }
                    }

                    let loading = true;
                    this.resetButtonState(this.elements.addAllToCart, loading);
                    const items = [];
                    for (const quantityInput of this.elements.quantityInput) {
                        const row = quantityInput.closest(this.selectors.rows);


                        const quantity = quantityInput.value;
                        const variantId = quantityInput.id.replace("Quantity-", "");
                        items.push({
                            id: variantId.toString(),
                            quantity: quantity
                        });

                    }


                    await this.addItems(items);
                });
            }


            validateInput(quantityInput) {
                if (quantityInput.value < 0 || isNaN(quantityInput.value)) {
                    quantityInput.value = 0;
                }

                if (Number(quantityInput.value) > Number(quantityInput.max)) {
                    // We are not adding a max when continue selling when out of stock
                    if (/\d/.test(quantityInput.max)) {
                        quantityInput.value = quantityInput.max;
                    }

                }
            }

            updatePrice(quantityInput) {
                const row = quantityInput.closest(this.selectors.rows);
                const priceElem = row.querySelector(this.selectors.price);
                const priceCompareElem = row.querySelector(this.selectors.priceCompare);

                let priceText = priceElem?.getAttribute('data-base-price') || priceElem?.textContent.trim() || '';
                priceText = priceText.replace(',', '.').replace(/[^0-9.]/g, '');
                const priceValue = parseFloat(priceText);
                const quantity = Math.max(Number(quantityInput.value), 1);
                if (!isNaN(priceValue)) {
                    const total = (priceValue * quantity).toFixed(2);
                    priceElem.textContent = total + ' lei';
                }

                if (priceCompareElem) {
                    let priceCompareText = priceCompareElem.getAttribute('data-base-price-compare') || priceCompareElem.textContent.trim();
                    priceCompareText = priceCompareText.replace(',', '.').replace(/[^0-9.]/g, '');
                    const priceCompareValue = parseFloat(priceCompareText);
                    if (!isNaN(priceCompareValue)) {
                        const totalCompare = (priceCompareValue * quantity).toFixed(2);
                        priceCompareElem.textContent = totalCompare + ' lei';
                    }
                }
            }

            resetInputs() {
                this.elements.quantityInput.forEach((quantityInput) => {
                    quantityInput.value = 0;

                    this.updatePrice(quantityInput);
                });
            }

            resetButtonState(button, loading = false) {
                if (loading) {
                    button.classList.add(this.classes.loading);
                } else {
                    button.classList.remove(this.classes.loading);
                }
                button.classList.remove(this.classes.success);
                button.classList.remove(this.classes.error);
            }

            getSectionsToRender() {
                return [
                    {
                        id: 'cart-icon-bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section'
                    },
                    {
                        id: 'CartDrawer',
                        selector: '#CartDrawer',
                        section: 'cart-drawer'
                    }
                ];
            }

            async addItems(items) {
                const cart = await this.getCartData();
                const updates = {};  // Change from array to object

                for (const item of items) {
                    const existingItem = cart.items.find((cartItem) => cartItem.variant_id === Number(item.id));
                    let newQuantity;

                    if (existingItem) {
                        newQuantity = existingItem.quantity + Number(item.quantity);
                    } else {
                        newQuantity = Number(item.quantity);
                    }

                    updates[item.id.toString()] = newQuantity; // Use the variant ID as the key
                }

                if (Object.keys(updates).length > 0) {
                    return await this.updateCartItems(updates);
                } else {
                    this.elements.addAllToCart.classList.remove(this.classes.loading);
                }

            }

            async updateCartItems(items) {
                try {
                    const body = JSON.stringify({
                        updates: items,
                        sections: this.getSectionsToRender().map((section) => section.section),
                        sections_url: window.location.pathname
                    });

                    const config = fetchConfig('javascript');
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';
                    config.body = body;

                    const response = await fetch(`${routes.cart_update_url}`, config);
                    const state = await response.text();
                    const parsedState = JSON.parse(state);

                    this.elements.addAllToCart.classList.remove(this.classes.loading);

                    this.addClassToElementTimeout(this.elements.addAllToCart, this.classes.success);
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0], cartData: parsedState });

                    this.cart?.renderContents(parsedState);
                    this.cart?.classList.remove('is-empty');
                    this.resetInputs()
                } catch (error) {

                    this.elements.addAllToCart.classList.remove(this.classes.loading);
                    this.resetInputs()
                    this.addClassToElementTimeout(this.elements.addAllToCart, this.classes.error);
                    console.error('Error updating cart items:', error);

                }
            }

            addClassToElementTimeout(element, className) {
                element.classList.add(className);

                setTimeout(() => {
                    element.classList.remove(className);
                }, 2000);
            }

            async getCartData() {
                const response = await fetch('/cart.js');
                return await response.json();
            }

            async addItem(variantId, quantity) {
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                const formData = new FormData(this.form);

                formData.append('id', Number(variantId));
                formData.append('quantity', quantity);


                if (this.cart) {
                    formData.append('sections', this.cart?.getSectionsToRender().map((section) => section.id));
                    formData.append('sections_url', window.location.pathname);

                    this.cart?.setActiveElement(document.activeElement);
                }

                config.body = formData;


                const response = await fetch(`${routes.cart_add_url}`, config);
                const cartData = await response.json();
                return cartData;
            }

            getSectionInnerHTML(html, selector = '.shopify-section') {
                return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
            }
        }
    );
}